export const specialCampaignConfig = {
  dateOffsetStart: -168, // 7 days in hours
  dateOffsetEnd: 24, // arrival date included
  arrivalAirport: 'AYT',
  serviceType: 'PT', // Package Trip (Pauschalreise)
  image: {
    src: '/public/assets/images/towel.png',
    alt: 'Bentour Reisen macht gluecklick',
  },
  title: 'Unser Willkommensgeschenk',
  subTitle: 'Ihr Hamam Tuch',
  text: `Verpassen Sie nicht Ihr Willkommens-Geschenk bei unserem Info-Gespräch* vor Ort. Je Buchung schenken wir unseren Gästen als Dankeschön für Ihre Teilnahme an unserem Info-Gespräch ein original türkisches Hamam Tuch. Kommen Sie vorbei - Ihr persönliches Stück Türkei wartet auf Sie!`,
  greeting: [
    'Wir wünschen Ihnen schon heute eine gute Anreise!',
    'Herzliche Grüße',
    'Ihr Bentour Reisen Team',
  ],
  note: '*Den Zeitpunkt erhalten Sie zusammen mit Ihrem Willkommens-Umschlag bei der Anreise',
};
